// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__ofXbH","container--v2":"styles_container--v2__goMTO","skeleton-animation":"styles_skeleton-animation__GFnyA"};